export default "__VITE_ASSET__BWORUxAF__"